import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchWishlist } from "../../../features/Pages/wishlist/redux/wishlistSlice";

function CartWishlist() {
  const dispatch = useDispatch();

  const wishlistCount = useSelector(
    (state) => state.wishlist?.wishlistCount ?? 0
  );

  useEffect(() => {
    const loadWishlist = () => {
      try {
        const selectedCustomer = JSON.parse(
          localStorage.getItem("selectedCustomer") || "null"
        );

        const customerId =
          selectedCustomer?.id ||
          selectedCustomer?.customer_id ||
          localStorage.getItem("customer_id");

        const userId =
          localStorage.getItem("user_id") || 1;

        if (!customerId) return;

        dispatch(
          fetchWishlist({
            userId: Number(userId),
            customerId: Number(customerId),
          })
        );
      } catch (error) {
        console.error("Wishlist fetch error:", error);
      }
    };

    loadWishlist();
  }, [dispatch]);

  return (
    <div className="box-wishlist box-wishlist-disable" style={{ marginTop: "1px" }}>
      <div className="link-Rottaion">
        <Link to="/wishlist">
          <i className="bi bi-heart hearticon"></i>
          <div className="badge-danger">
            {wishlistCount}
          </div>
        </Link>
      </div>
    </div>
  );
}
export default CartWishlist;